export default __webpack_public_path__ + "static/media/setproduct-logo.1ebb0ce4.svg";